import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'



interface FontAmountState extends ListState<any> {
    paymentUrl: string;
}

class FontOrderMutations extends ListMutations<any>{

}
class FontAmount extends ListModule<FontAmountState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        paymentUrl: null
    }
    actions = {
        async getAll(context: ActionContext<FontAmountState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Recharge/GetAmountList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async generatePaymentUrl(context: ActionContext<FontAmountState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/Recharge/GeneratePaymentUrl', { params: payload.data });
            context.state.paymentUrl = reponse.data.result;
        },

        async confirmPayment(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/Recharge/ConfirmPayment', { params: payload.data });
        }

    };
    mutations = {
        setCurrentPage(state: FontAmountState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FontAmountState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const fontAmount = new FontAmount();
export default fontAmount;